var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SelectField } from '../SelectField';
var SEPARATOR = '|';
var toValue = function (sort) { return "".concat(sort.by).concat(SEPARATOR).concat(sort.order); };
var fromValue = function (value) {
    var _a = value.split(SEPARATOR), by = _a[0], order = _a[1];
    return { by: by, order: order };
};
export var SortField = function (props) {
    var handleChange = function (value) {
        props.onChange(fromValue(value));
    };
    var options = props.options.map(function (_a) {
        var by = _a.by, order = _a.order, option = __rest(_a, ["by", "order"]);
        return (__assign(__assign({}, option), { value: toValue({ by: by, order: order }) }));
    });
    return (_jsx("div", __assign({ className: "localina-sortfield" }, { children: _jsx(SelectField, { label: props.label, options: options, value: toValue(props.sort), disabled: props.disabled, onChange: handleChange }) })));
};
